import { useDebounce } from 'react-use';
import { useFormContext, useWatch } from 'react-hook-form';
import { useState } from 'react';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { CaseStatus } from '@/api/apis/case';
import { useDuplicatesForCaseQuery } from '@/queries/case';

type Props = {
  excludeCaseId?: string;
  debounceMs?: number;
  caseStatus?: CaseStatus;
};

export const useDuplicateCaseWarning = (props: Props) => {
  const { control } = useFormContext<CaseFormType>();
  const { excludeCaseId, debounceMs = 200, caseStatus = CaseStatus.Draft } = props;
  const donorId = useWatch({ control, name: 'donorId' });
  const organType = useWatch({ control, name: 'organType' });
  const [{ donorId: debouncedDonorId, organType: debouncedOrganType }, setDebouncedFields] = useState({
    donorId,
    organType,
  });

  useDebounce(
    () => {
      setDebouncedFields({ donorId, organType });
    },
    debounceMs,
    [donorId, organType],
  );

  const { data: { items: duplicates = [] } = {} } = useDuplicatesForCaseQuery({
    caseStatus,
    excludeCaseId,
    donorId: debouncedDonorId,
    organType: debouncedOrganType,
  });

  return { isDuplicate: duplicates.length > 0 };
};
